module.exports = __webpack_public_path__ + "static/media/5_apply.d4a88dcc.png";